import styles from "./TopUI.module.css";
import ClockCount from "./ClockCount";
import HUDInventory from "./HUDInventory";
import FlourCount from "./FlourCount";
import EditButton from "./EditButton";
import RestartLevelButton from "./RestartLevelButton";
import ChangeLevelButton from "./ChangeLevelButton";
import SettingsButton from "./SettingsButton";

export default function TopUI({ level }) {
  return (
    <div className={styles.topBar}>
      <div className={styles.topBarLeft}>
        <ChangeLevelButton />
        <FlourCount level={level} />
        <ClockCount level={level} />
        <HUDInventory level={level} />
      </div>

      <div className={styles.topBarRight}>
        <EditButton level={level} />
        <SettingsButton level={level} />
        <RestartLevelButton level={level} />
      </div>
    </div>
  );
}
